import { Grid } from '@mui/material';
import React from 'react';
import FailureScreen from 'src/frontend-common/components/FailureScreen';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';

import OverviewCustomerList from 'src/components/OverviewComponents/CustomersList';
import { useGetCustomersQuery } from 'src/redux/services/customers';
import { Props, getFetchPayload, nameScoreCustomerTable, getBestAndWorst } from 'src/components/TopIdentities/common';

const TopIdentities: React.FC<Props> = ({ customersFilters, pathToDetail, tableTitle, type, navigateTo }) => {
  const {
    data: customers,
    isFetching: isCustomersLoading,
    isError: isCustomersError,
  } = useGetCustomersQuery({
    ...customersFilters,
    sort_direction: type === 'best' ? 'desc' : 'asc',
    sort_field: 'score',
    ...getFetchPayload(pathToDetail),
  });

  const getTabNumber = () => {
    switch (pathToDetail) {
      case 'customer':
        return 1;
      case 'customerPhone':
        return 2;
      case 'customerEmail':
        return 3;
      case 'customerIpAddress':
        return 4;
      case 'customerDomainIntelligence':
        return 5;
    }
  };
  return (
    <Grid item xs={12} key={tableTitle}>
      {isCustomersLoading && <LoadingScreen variant="circle" />}
      {isCustomersError && <FailureScreen>An error occurred while fetching the data. Please try to refresh the page.</FailureScreen>}
      {customers && (
        <OverviewCustomerList
          title={tableTitle}
          customers={getBestAndWorst(pathToDetail, type === 'best', customers.items)}
          sort={type === 'best' ? 'scoreDesc' : 'scoreAsc'}
          tableStructure={nameScoreCustomerTable(pathToDetail)}
          seeMoreToPath={`/lookups/?tab=${getTabNumber()}`}
          navigateTo={navigateTo}
        />
      )}
    </Grid>
  );
};

export default TopIdentities;
